// utils/format.js
// Number and text formatting utilities

/**
 * Format large numbers with K, M, B suffixes
 */
export function formatNumber(num) {
    if (num < 1000) return Math.floor(num).toString();
    if (num < 10000) return (num / 1000).toFixed(1) + 'K';
    if (num < 1000000) return Math.floor(num / 1000) + 'K';
    if (num < 1000000000) return (num / 1000000).toFixed(1) + 'M';
    return (num / 1000000000).toFixed(1) + 'B';
}

/**
 * Format time in seconds to readable format
 * Handles hours, minutes, seconds cleanly (e.g., "1h 30m", "45m", "30s")
 */
export function formatTime(seconds) {
    // Round to whole seconds
    seconds = Math.round(seconds);

    if (seconds < 60) return `${seconds}s`;

    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins < 60) {
        // Only show seconds if non-zero
        return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
    }

    const hours = Math.floor(mins / 60);
    const remainMins = mins % 60;

    // Only show minutes if non-zero
    return remainMins > 0 ? `${hours}h ${remainMins}m` : `${hours}h`;
}

/**
 * Format percentage
 */
export function formatPercent(value, decimals = 1) {
    return (value * 100).toFixed(decimals) + '%';
}

/**
 * Add commas to numbers (1,234,567)
 */
export function formatWithCommas(num) {
    return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default {
    formatNumber,
    formatTime,
    formatPercent,
    formatWithCommas,
};